const channels = [
  { icon: 'ri-mail-send-line', title: '投稿爆料', desc: '身边有值得被看见的热点线索？把时间、地点与可核实信源发给我们。', value: 'tougao@chigua-hot.com', href: 'mailto:tougao@chigua-hot.com' },
  { icon: 'ri-hand-coin-line', title: '商务合作', desc: '品牌联名、栏目冠名与活动合作，欢迎与商业化团队对接洽谈。', value: 'bd@chigua-hot.com', href: 'mailto:bd@chigua-hot.com' },
  { icon: 'ri-feedback-line', title: '意见反馈', desc: '对内容有疑问、发现不实信息或希望优化体验，随时告诉我们。', value: 'help@chigua-hot.com', href: 'mailto:help@chigua-hot.com' },
];

export default function ContactCta() {
  return (
    <section id="contact" className="scroll-mt-24 py-12 md:py-16 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="rounded-2xl bg-foreground-950 text-background-100 overflow-hidden relative">
          <i className="ri-fire-fill absolute -right-8 -bottom-8 text-[180px] text-primary-500/20 rotate-12" aria-hidden="true" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 p-6 md:p-10 lg:p-12 relative z-10">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/20 text-primary-200 border border-primary-500/30 px-3 py-1 text-xs font-semibold">
                <i className="ri-radar-line text-sm" aria-hidden="true" /> 全网线索雷达
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black leading-snug text-background-50">
                有线索？让我们第一时间帮你跟进
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-200/90 leading-relaxed max-w-lg">
                无论是一手现场、疑似翻车还是刷屏名场面，只要你愿意提供线索，编辑部都会认真对待。
                投稿请尽量附上时间、地点、已知事实与可核实的信息来源，我们一起把瓜吃透。
              </p>
              <div className="mt-6 flex flex-col gap-2.5 text-sm text-background-200">
                <span className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true" /> 线索一经采用将匿名或署名致谢</span>
                <span className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true" /> 涉及隐私与未成年人信息优先保护</span>
                <span className="flex items-center gap-2"><i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true" /> 对存疑内容进行信源等级标注</span>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 xl:grid-cols-3 gap-3 md:gap-4">
              {channels.map((c) => (
                <a
                  key={c.title}
                  href={c.href}
                  className="flex flex-col gap-2 rounded-xl border border-background-700 bg-background-800/60 p-4 hover:bg-background-700/60 hover:border-accent-500/40 transition cursor-pointer"
                >
                  <span className="flex w-9 h-9 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                    <i className={`${c.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <h3 className="text-sm font-bold text-background-50">{c.title}</h3>
                  <p className="text-xs text-background-200/80 leading-relaxed">{c.desc}</p>
                  <span className="mt-auto inline-flex items-center gap-1 text-xs font-medium text-accent-300 break-all">{c.value}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}